import { render, staticRenderFns } from "./seach.vue?vue&type=template&id=54e5b2aa&scoped=true&"
import script from "./seach.vue?vue&type=script&lang=js&"
export * from "./seach.vue?vue&type=script&lang=js&"
import style0 from "./seach.vue?vue&type=style&index=0&id=54e5b2aa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e5b2aa",
  null
  
)

export default component.exports